<template>
  <div class="card">
    <template v-if="detailData&&detailData.id">
      <div class="detail-layout">
        <div class="detail-left">
          <div class="plan-summary">
            <div class="summary-header">
              <div class="summary-meta">
                <div class="meta-item">
                  <span class="meta-label">计划名称</span>
                  <span class="meta-value">{{ detailData.planName || '--' }}</span>
                </div>
                <div class="meta-item">
                  <span class="meta-label">开始时间</span>
                  <span class="meta-value">{{ detailData.intervalStartTime || '--' }}</span>
                </div>
                <div class="meta-item">
                  <span class="meta-label">计划编号</span>
                  <span class="meta-value">{{ detailData.planNo || '--' }}</span>
                </div>
                <div class="meta-item">
                  <span class="meta-label">更新时间</span>
                  <span class="meta-value">{{ detailData.updateTime || '--' }}</span>
                </div>
              </div>
              <div class="progress-steps" v-if="detailData.produceScheduleList && detailData.produceScheduleList.length">
                <div
                  v-for="(step, index) in detailData.produceScheduleList"
                  :key="index"
                  class="progress-step"
                >
                  <div class="step-icon" :class="{ completed: step.optName }">
                    <i class="el-icon-circle-check"></i>
                  </div>
                  <div class="step-info">
                    <div class="step-name">{{ step.stepName }}</div>
                    <div class="step-status" v-if="step.optName">{{ step.stepName }}</div>
                  </div>
                  <div class="step-line" v-if="index !== detailData.produceScheduleList.length - 1"></div>
                </div>
              </div>
            </div>

          </div>

          <div class="timeline-panel">
            <div class="timeline-list" v-if="timelineList.length">
              <div v-for="(op, opIndex) in timelineList" :key="opIndex" class="timeline-item">
                <div class="time-label">
                  <div class="time">{{ op.createTime || '暂无时间' }}</div>
                  <div class="date">{{ op.statisticDate || '' }}</div>
                </div>
                <div class="timeline-card">
                  <div class="timeline-card-left">
                    <div class="timeline-header">
                      <div class="timeline-title">{{ splitstepName(op) }}</div>
                      <!--                    <span
                                            class="timeline-status"
                                            :class="{ completed: op.executeStatus === 2 }"
                                          >
                                            {{ op.executeStatus === 2 ? '已完成' : op.executeStatus === 1?'进行中':'未开始' }}
                                          </span> -->
                    </div>
                    <div class="timeline-content">{{ splitstepName(op, 'Msg') }}</div>
                    <div class="timeline-footer">
                      <span v-if="op.createName">操作人：{{ op.createName }}</span>
                      <span v-if="op.totalDuration">耗时：{{ op.totalDuration }}</span>
                    </div>
                  </div>
                  <div class="timeline-card-right">
                    <img v-if="op.executeStatus===2" class="frame" src="../../../../../public/img/autoprocess/Frame1.png" alt="">
                    <img v-if="op.executeStatus===1" class="frame" src="../../../../../public/img/autoprocess/Frame0.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="timeline-empty" v-else>暂无时间轴数据</div>
          </div>
        </div>

        <div class="detail-right">
          <div class="detail-card">
            <div class="detail-card__header">
              <img src="../../../../../public/img/autoprocess/plan-logo.png" alt="logo" />
              <div class="header-content">
                <div class="header-label">计划名称</div>
                <div class="header-value">{{ detailData.planName || '--' }}</div>
              </div>
            </div>
            <div class="detail-card__meta">
              <div class="meta-item">
                <span class="meta-label">创建人</span>
                <span class="meta-value">{{ detailData.createName || '--' }}</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">创建时间</span>
                <span class="meta-value">{{ detailData.createTime || '--' }}</span>
              </div>
            </div>
            <div class="detail-card__divider"></div>
            <div class="detail-card__grid">
              <div class="grid-item">
                <span class="grid-label">计划编号</span>
                <span class="grid-value">{{ detailData.planNo || '--' }}</span>
              </div>
              <div class="grid-item">
                <span class="grid-label">当前状态</span>
                <span class="grid-value" :class="getPlanStateClass(detailData.planState)">
                  {{ getPlanStateName(detailData.planState) || '--' }}
                </span>
              </div>
              <div class="grid-item">
                <span class="grid-label">{{ [1, 3].includes(detailData.businessType) ? '入库总量' : '出库总量' }}</span>
                <span class="grid-value">{{ detailData.planExecuteWeight || '0' }} 吨</span>
              </div>
              <div class="grid-item">
                <span class="grid-label">总耗时</span>
                <span class="grid-value">{{ detailData.totalDuration || '--' }}</span>
              </div>
              <div class="grid-item">
                <span class="grid-label">开始时间</span>
                <span class="grid-value">{{ detailData.statisticStartTime || '--' }}</span>
              </div>
              <div class="grid-item">
                <span class="grid-label">完成时间</span>
                <span class="grid-value">{{ detailData.statisticEndTime || '--' }}</span>
              </div>
              <div class="grid-item">
                <span class="grid-label">备注</span>
                <span class="grid-value">{{ detailData.remark || detailData.remarkDesc || '暂无备注' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  inject: ["_parentThis"],
  computed: {
    detailData () {
      return this._parentThis.detailData || {};
    },
    timelineList () {
      return Array.isArray(this._parentThis.planTimelineList)
        ? this._parentThis.planTimelineList
        : [];
    }
  },
  data () {
    return {};
  },
  mounted () { },
  methods: {
    splitstepName (row, type = 'stepName') {
      if (!row.stepName) return row.stepName
      const stepMsg = row.stepName.split(`\n`)
      if (stepMsg.length == 2) {
        return type == 'stepName' ? stepMsg[0] : stepMsg[1]
      } else {
        return type == 'stepName' ? row.stepName : ''
      }
    },
    getPlanStateName (PlanNo) {
      let PlanName = ''
      switch (PlanNo + '') {
        case '0':
          PlanName = '未开始'
          break;
        case '1':
          PlanName = '进行中'
          break;
        case '2':
          PlanName = '已完成'
          break;
      }

      return PlanName
    },
    getPlanStateClass (planState) {
      switch ((planState === 0 || planState) ? String(planState) : '') {
        case '0':
          return 'is-wait'
        case '1':
          return 'is-progress'
        case '2':
          return 'is-done'
        default:
          return ''
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.card {
  background: transparent;
  padding: 0;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.detail-layout {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 10px;
  height: 100%;
  min-height: 0;
}

.detail-left,
.detail-right {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
}

.plan-summary {
  padding: 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.summary-header {
  display: grid;
  align-items: start;
  background: #E0E6F2;
  border-radius: 4px;
  padding: 10px 5px;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
}

.summary-title-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.summary-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a2440;
}

.summary-id {
  font-size: 14px;
  color: #4f5c7a;
}

.summary-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(140px, 1fr));
  gap: 10px 8px;
  padding: 10px 5px;
}

.meta-label {
  font-size: 12px;
  color: #6f7a92;
}

.meta-value {
  font-size: 13px;
  font-weight: 600;
  color: #1f2b4d;
  line-height: 18px;
}

.progress-steps {
  display: flex;
  padding: 14px 2px;
}

.progress-step {
  display: flex;
  align-items: center;
  gap: 6px;
  position: relative;
}

.step-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(209, 218, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7b86a6;
  transition: all 0.2s ease;

  &.completed {
    background: linear-gradient(135deg, #2f51ff 0%, #55a7ff 100%);
    color: #fff;
  }
}

.step-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.step-name {
  font-size: 14px;
  font-weight: 600;
  color: #1f2b4d;
}

.step-status {
  font-size: 12px;
  color: #2563eb;
}

.step-line {
  width: 40px;
  height: 2px;
  background: rgba(126, 143, 197, 0.3);
  border-radius: 2px;
}

.timeline-panel {
  flex: 1;
  padding: 18px 0px 18px 18px;
  //box-shadow: 0 16px 40px -32px rgba(31, 43, 77, 0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #E0E6F2;
  border-radius: 4px;
}

.timeline-list {
  overflow-y: auto;
  padding-right: 6px;
}

.timeline-item {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 16px;
  padding: 12px 0;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 112px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(180deg, rgba(51, 82, 255, 0.35), rgba(51, 82, 255, 0.05));
  }
}

.timeline-item:last-child::before {
  bottom: 50%;
}

.time-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #4f5c7a;
  font-size: 12px;
  align-items: flex-end;
  padding-right: 12px;
}

.timeline-card {
  background: #f5f7ff;
  border-radius: 14px;
  padding: 10px 18px 8px 14px;
  border: 1px solid rgba(84, 110, 255, 0.12);
  box-shadow: 0 14px 32px -30px rgba(31, 43, 77, 0.35);

  display: flex;
  justify-content: space-between;
  flex-direction: row;
  line-height: 35px;
  align-items: center;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #1f2b4d;
}

.timeline-status {

}

.timeline-content {
  font-size: 13px;
  color: #5b6686;
  line-height: 18px;
}

.timeline-footer {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #7b86a6;
}

.timeline-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9aa5c2;
  font-size: 14px;
}

.detail-right {
  height: 100%;
  min-height: 0;
}

.detail-right .detail-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 18px 36px -32px rgba(31, 43, 77, 0.4);
  border: 1px solid #e3e8f5;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
}

.detail-card__header {
  display: flex;
  align-items: center;
  gap: 18px;

  img {
    width: 68px;
  }
}

.header-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.header-label {
  font-size: 14px;
  color: #7b86a6;
}

.header-value {
  font-size: 14px;
  font-weight: 600;
  color: #1b255a;
}

.detail-card__meta {

}

.meta-item {
  display: flex;
  font-size: 14px;
  color: #3d4863;
  flex-direction: column;
  gap: 4px;

  .meta-label {
    color: #7b86a6;
    margin-right: 8px;
  }
}

.meta-item .meta-value {
  font-weight: 600;
  color: #1b255a;
  font-size: 13px;
}

.detail-card__divider {
  height: 1px;
  background: linear-gradient(90deg, rgba(205, 213, 235, 0), rgba(205, 213, 235, 0.8), rgba(205, 213, 235, 0));
}

.detail-card__grid {

}

.grid-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  padding: 0;
  height: 30px;
}

.grid-label {
  font-size: 13px;
  color: #7b86a6;
}

.grid-value {
  font-size: 13px;
  font-weight: 600;
  color: #1b255a;
}

.grid-value.is-wait {
  color: #9aa5bf;
}

.grid-value.is-progress {
  color: #2563eb;
}

.grid-value.is-done {
  color: #1890ff;
}

</style>



